

namespace PaperTrail.NewsletterControl {
    @Serenity.Decorators.registerEditor('PaperTrail.NewsletterControl.StoryImageEditor')
    export class StoryImageEditor extends  Serenity.Extensions.GridEditorBase<StoryImageRow> {
        protected getColumnsKey() { return StoryImageColumns.columnsKey; }
        protected getDialogType() { return StoryImageEditorDialog; }
        protected getLocalTextPrefix() { return StoryImageRow.localTextPrefix; }

        constructor(container: JQuery) { 
            super(container);
        }

        protected getAddButtonCaption() {
            return "Upload Image";
        }

        validateEntity(row: StoryImageRow, id) {
             
            return true;
        }
         
        private _storyID: number;
        get storyID() {
            return this._storyID;
        }

        set storyID(value: number) {
            if (value !== this._storyID) {
                this._storyID = value;
                this.refresh();
            }
        }
    }
}